enum PaymentDomesticUpdateStatus {
  STOP = 'STOP',
  REACTIVATE = 'REACTIVATE',
  IGNORLIMIT = 'IGNORLIMIT',
}

export default PaymentDomesticUpdateStatus;
